export const DARK__BACKGROUND = 'oklch(0.145 0 0)'
export const LIGHT_THEME_COLOR = 'rgb(255, 255, 255)'
